<div class="overlay">
  <mat-spinner  [diameter]="30"></mat-spinner>

</div>
